import type { FastifyInstance } from 'fastify'
import { db } from '../../core/database/firebase.js'
import { ProfileService } from './profile.service.js'
import { ProfileController } from './profile.controller.js'
import { profileRoutes } from './profile.routes.js'

export async function profileModule(app: FastifyInstance) {
  const service = new ProfileService(db)
  const controller = new ProfileController(service)
  await profileRoutes(app, controller)
}
